module.exports = __webpack_public_path__ + "static/media/interaction-toggle-checkmark-multi-select-on.46687f41.svg";